import axiosInstance from './axiosInstance';

const videoService = {
  list: (params = {}) =>
    axiosInstance.get('/admin/videos', { params }),

  getFilterYears: () =>
    axiosInstance.get('/admin/videos/filters/years'),

  getById: (id) =>
    axiosInstance.get(`/admin/videos/${id}`),

  create: (data) =>
    axiosInstance.post('/admin/videos', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/videos/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/videos/${id}`),
};

export default videoService;
